<div class="table-category">
    <div class="row">
        <div class="col-6 m-l-20">
            <div class="row">
                <div class="col-8 name-report">
                    {{table.header.question}}
                </div>
                <div class="col-2 assessments">
                    <ng-container *ngIf="isFirst">
                        {{table.header.value}}
                    </ng-container>
                </div>
                <div class="col-2 pl-0 pr-0 assessments"
                     *ngFor="let period of table.header.previousPeriods">
                    <ng-container *ngIf="isFirst">
                        {{period}}
                    </ng-container>
                </div>
            </div>
            <div class="row" *ngFor="let row of table.body.rows">
                <div class="col-4 pr-0">
                    <div class="pt-1">
                        {{row.category}}
                    </div>
                </div>
                <div class="col-4 progress-parent">
                    <div class="pt-1">
                        <div [ngClass]="['progress', row.type + '-opacity']">
                            <div [ngClass]="['progress-bar', row.type]"
                                 [ngStyle]="{'width': (row.average / row.maxValue) * 100 + '%'}"></div>
                        </div>
                    </div>
                </div>
                <div class="col-2">
                    <div class="pt-1 font-weight-bold">
                        {{row.average}}
                    </div>
                </div>
                <div class="col-2 pl-0 period-years" *ngFor="let period of row.previousPeriodValues">
                    <div class="pt-1" *ngFor="let scorePoint of period">
                        {{scorePoint.value}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>